<template>
  <div class="item">
    <div class="visual">
      <img
        v-if="content.image2"
        class="visual-image"
        :class="{'hidden': !expanded}"
        :src="getImage(content.image2)"  />
      <transition name="fade">
        <img
          v-if="content.image && !expanded"
          class="visual-image"
          :src="require(`@/assets/${content.image}`)"  />
      </transition>
    </div>
    <div class="content">
      <div
        v-if="content.extraBomb"
        class="extra-bombs">
        <img
          class="bomb1"
          :src="getImage('img/bomb1.svg')" />
        <img
          class="bomb2"
          :src="getImage('img/bomb2.svg')" />
      </div>
      <div class="text" v-html="`<strong>${content.title}</strong> - ${content.text}`" /> <!-- title is niet overal beschikbaar -->
    </div>
    <transition name="slide">
      <div
        v-if="content.extraText && expanded"
        class="content highlight">
        <div class="text" v-html="content.extraText" />
      </div>
    </transition>
    <div v-if="content.cards" class="cards">
      <div class="text card-text" v-html="content.text2" />
      <div class="card-holder">
        <div
          v-for="(card, key) in content.cards"
          :key="key"
          class="card">
          <img
            class="card-image"
            :src="require(`@/assets/${card.image}`)" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    content: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      expanded: false
    }
  },
  mounted () {
    if (this.content.extraText) {
      setTimeout(() => {
        window.addEventListener('scroll', () => {
          this.checkViewport()
        })
      }, 1000)
    }
  },
  methods: {
    getImage (url) {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/${url}`)
    },
    checkViewport () {
      if (this.$el && this.$el.classList.contains('above-viewport')) {
        this.expanded = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .item {
    line-height: 0;
  }

  .content {
    position: relative;
    padding: 26px;
    color: $nos-op3-dark-blue;
    background-color: $nos-op3-white;
    z-index: 5;
  }

  .title {
    margin-bottom: 10px;
    font-size: 24px;
    line-height: 24px;
    font-weight: bold;
  }

  .text {
    font-size: 18px;
    line-height: 28px;
  }

  .highlight {
    margin-top: -30px;
    padding-top: 50px;
    background-color: $nos-op3-red;
    z-index: 4;
  }

  .cards {
    margin-top: 30px;
    margin-bottom: -120px;
  }

  .card-holder {
    @include tablet {
      display: flex;
      flex-flow: row nowrap;
    }
  }

  .card-text {
    padding: 0 26px;
    margin-bottom: 25px;
  }

  .card {
    text-align: center;
  }

  .card-image {
    width: 100%;
    max-width: 300px;
    @include tablet {
      max-width: none;
    }
  }

  .visual {
    width: 90%;
    margin: 0 auto;
    position: relative;
  }

  .visual-image {
    width: 100%;
    transition: opacity 1s linear
  }

  .hidden {
    opacity: 0;
  }

  .visual-image + .visual-image {
    position: absolute;
    left: 0;
    top: 0;
  }

  .extra-bombs {
    position: absolute;
    width: 100%;
    height: 40px;
    margin-top: -20px;
    top: 0;
    left: 0;
  }

  .bomb1 {
    width: 30%;
    position: absolute;
    left: 18%;
    bottom: 0;
  }

  .bomb2 {
    width: 20%;
    position: absolute;
    left: 65%;
    bottom: 0;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 2s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .slide-enter-active, .slide-leave-active {
    transition: all 1s 1s;
  }
  .slide-enter, .slide-leave-to {
    opacity: 0;
    margin-top: -100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/InfoBlock.vue